const baseUrl = 'https://api.rana365.online/api';

export default baseUrl;



// WEBPACK FOOTER //
// ./src/components/baseUrl.js